/* Development urls */

// export const ERP_url = "/erp/api/erp";
// export const UPDASP_link = "https://updasp-demo.agrani.io";

/* production urls */

export const ERP_url = "/erp-gateway/api";
export const UPDASP_link = "https://updasp.agrani.io";
